// extracted by mini-css-extract-plugin
export default {"loadingScreen":"Loading_loadingScreen__UPyv5"};